import React, { useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import FormFiltriContratti from "./FormFiltriContratti.tsx";
import FormFiltriClienti from "./FormFiltriClienti.tsx";
import FormFiltriCantieri from "./FormFiltriCantieri.tsx";
import FormFiltriEventi from "./FormFiltriEventi.tsx";
import "./FiltroSidenav.css";

interface FiltroSidenavProps {
  visible: boolean;
  onHide: () => void;
  setTable: (x: any) => void;
}

// Stato filtri per i clienti
interface FiltroClienteState {
  ragioneSociale: string;
  protocollo: string;
  partitaIva: string;
  sdi: string;
  codiceFiscale: string;
  citta: string;
  cap: string;
}

// Stato filtri per i cantieri
interface FiltroCantieriState {
  nome: string;
  citta: string;
  cap: string;
  dataInizioStart: string;
  dataInizioEnd: string;
  dataFineStart: string;
  dataFineEnd: string;
}

// Stato filtri per i contratti
interface FiltroContrattiState {
  codice: string;
  ragioneSociale: string;
  dataInizioStart: string;
  dataInizioEnd: string;
  dataFineStart: string;
  dataFineEnd: string;
}

// Stato filtri per gli eventi
interface FiltroEventiState {
  titolo: string;
  dataOraStart: string;
  dataOraEnd: string;
  scadenzaStart: string;
  scadenzaEnd: string;
  cantiereNome: string;
  contrattoQuadroCodice: string;
}

const FiltroSidenav: React.FC<FiltroSidenavProps> = ({
  visible,
  onHide,
  setTable,
}) => {
  const location = useLocation();

  // Filtri per committenti
  const [filtroClienteState, setFiltroClienteState] =
    useState<FiltroClienteState>({
      ragioneSociale: "",
      protocollo: "",
      partitaIva: "",
      sdi: "",
      codiceFiscale: "",
      citta: "",
      cap: "",
    });

  // Filtri per cantieri
  const [filtroCantieriState, setFiltroCantieriState] =
    useState<FiltroCantieriState>({
      nome: "",
      citta: "",
      cap: "",
      dataInizioStart: "",
      dataInizioEnd: "",
      dataFineStart: "",
      dataFineEnd: "",
    });

  // Filtri per contratti
  const [filtroContrattiState, setFiltroContrattiState] =
    useState<FiltroContrattiState>({
      codice: "",
      ragioneSociale: "",
      dataInizioStart: "",
      dataInizioEnd: "",
      dataFineStart: "",
      dataFineEnd: "",
    });

  // Filtri per eventi
  const [filtroEventiState, setFiltroEventiState] = useState<FiltroEventiState>(
    {
      titolo: "",
      dataOraStart: "",
      dataOraEnd: "",
      scadenzaStart: "",
      scadenzaEnd: "",
      cantiereNome: "",
      contrattoQuadroCodice: "",
    }
  );

  const renderForm = () => {
    if (location.pathname === "/contratti") {
      return (
        <FormFiltriContratti
          onClose={onHide}
          setTable={setTable}
          filtroContratto={filtroContrattiState}
          setFiltroContratto={setFiltroContrattiState}
        />
      );
    } else if (location.pathname === "/committenti") {
      return (
        <FormFiltriClienti
          onClose={onHide}
          setTable={setTable}
          filtroCliente={filtroClienteState}
          setFiltroCliente={setFiltroClienteState}
        />
      );
    } else if (location.pathname === "/cantieri") {
      return (
        <FormFiltriCantieri
          onClose={onHide}
          setTable={setTable}
          filtroCantiere={filtroCantieriState}
          setFiltroCantiere={setFiltroCantieriState}
        />
      );
    } else if (location.pathname === "/eventi") {
      return (
        <FormFiltriEventi
          onClose={onHide}
          setTable={setTable}
          filtroEvento={filtroEventiState}
          setFiltroEvento={setFiltroEventiState}
        />
      );
    } else {
      return null;
    }
  };

  return (
    <Offcanvas show={visible} onHide={onHide} placement="end" className="round">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="title-text-center">Filtri</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>{renderForm()}</Offcanvas.Body>
    </Offcanvas>
  );
};

export default FiltroSidenav;
